import { Company } from './company.model';

export class Issuer extends Company {

}
